import React from "react";
import { withContextFactory } from "../../contexts/contexts.utils";
import { HotspotsContext, IHotspotsContext } from "./HotspotsContext";

export interface WithHotspots {
    hotspots: IHotspotsContext;
}

export const withHotspots = withContextFactory<WithHotspots>(HotspotsContext, "hotspots");